import styled from 'styled-components';
import { BUTTON_VARIANTS, IconButton } from 'ui/button';
import { IconButtonProps } from 'ui/button/IconButton';
import { PerformanceAlerts16 } from 'ui/icons';
import { colors, spacing } from 'ui/theme';
import { Tooltip } from 'ui/tooltip';

const StyledIconButton = styled(IconButton)`
  && {
    margin: 0;
    width: fit-content;
    height: fit-content;
    padding: ${spacing.quarter};
    border: unset;
    border-radius: 50%;
    background-color: ${colors.purple20};
  }

  &:hover {
    border: 1px solid ${colors.borderInteractive};
  }
`;

const StyledTooltip = styled(Tooltip)`
  display: flex;
  justify-content: center;
  align-items: center;
  width: ${spacing.plusHalf};
  height: ${spacing.plusHalf};
`;

export const AlertsHistoryBadge = ({ onClick, ...rest }: IconButtonProps) => (
  <StyledTooltip tooltipContent="Alert in the past 24 hours" isEnabled>
    <StyledIconButton
      id="performance-alerts-icon-badge"
      variant={BUTTON_VARIANTS.TEXT}
      onClick={onClick}
      {...rest}
    >
      <PerformanceAlerts16 />
    </StyledIconButton>
  </StyledTooltip>
);
